import { ModuleRoutes } from '@core/declarations/router'

const Login = () => import('@core/modules/Auth/views/Login/Login.vue')
const PasswordSetup = () => import('@core/modules/Auth/views/PasswordSetup/PasswordSetup.vue')
const SignupOverview = () => import('@core/modules/Auth/views/Signup/SignupOverview.vue')
const SignupLanding = () => import('@core/modules/Auth/views/Signup/SignupLanding/SignupLanding.vue')
const ClubEnrollmentInfo = () => import('@core/modules/Auth/views/Signup/ClubEnrollmentInfo/ClubEnrollmentInfo.vue')
const UserSignup = () => import('@core/modules/Auth/views/Signup/UserSignup/UserSignup.vue')

const routes: ModuleRoutes = {
  name: 'Auth',
  basePath: '/auth',
  routes: [
    {
      path: '/login',
      name: 'authLogin',
      component: Login,
      isPublic: true,
      meta: {
        isPublic: true,
        tabTitle: 'Access',
        navigationType: 'clean',
      },
    },
    {
      path: '/logout',
      name: 'authLogout',
      component: Login,
      isPublic: true,
      meta: {
        isPublic: true,
        tabTitle: 'Access',
        navigationType: 'clean',
      },
    },
    {
      path: '/password/recover',
      name: 'passwordRecovery',
      component: PasswordSetup,
      isPublic: true,
      meta: {
        isPublic: true,
        tabTitle: 'Password recovery',
        navigationType: 'clean',
      },
    },
    {
      path: '/activation',
      name: 'userActivation',
      component: PasswordSetup,
      isPublic: true,
      meta: {
        tabTitle: 'User activation',
        navigationType: 'clean',
      },
    },
    {
      path: '',
      name: 'authSignup',
      component: SignupOverview,
      isPublic: true,
      meta: {
        tabTitle: 'Signup',
        navigationType: 'clean',
      },
      children: [
        {
          path: '/auth/signup',
          name: 'authSignupLanding',
          component: SignupLanding,
          meta: {
            tabTitle: 'Signup',
            navigationType: 'clean',
          },
        },
        {
          path: '/auth/signup/club-enrollment-info',
          name: 'authSignupClubEnrollmentInfo',
          component: ClubEnrollmentInfo,
          meta: {
            tabTitle: 'Club enrollment info',
            navigationType: 'clean',
          },
        },
        {
          path: '/auth/signup/user-signup',
          name: 'authUserSignupForm',
          component: UserSignup,
          meta: {
            tabTitle: 'User signup',
            navigationType: 'clean',
          },
        },
      ],
    },
  ],
}

export default routes
